import React from 'react'
import './App.scss';
import Navbar from './Common/Navbar';
import { HeroSection } from './HeroSection/HeroSection';
import VideoSlider from './VideoCrads/VideoCards';
import { IntroSection } from './IntroSection/IntroSection';
import { Branding } from './Branding/Branding';
import { StorySection } from './storySection/StorySection';
import { Features } from './Features/Features';
import { FeaturesCell } from './Features/FeaturesCell';
import { BottomSecton } from './Footer/BottomSecton';
import { Footer } from './Footer/Footer';
import { AuthWrapper } from './AuthWrapper'
import { Helmet } from "react-helmet";
export const HomePage = () => {
  return (
   <AuthWrapper>
    <Helmet>
<title>Khadim Welfare Foundation | Empowering Lives Through Hope</title>
      </Helmet>
    <div className="App" >
      <Navbar parent={'home'}/>
      <HeroSection/>
      <VideoSlider/>
      <IntroSection/>
      <Branding/>
      <StorySection/>
      <Features/>
      <FeaturesCell/>
      <BottomSecton/>
      <Footer/>
    </div>
    </AuthWrapper>
    
  )
}
